export const BASE_HOST_PROD = window.location.origin;
export const LOCALHOST = 'http://localhost:';
export const API_URL_VERSION = 'v1';
export const API = 'api';

const MODE = process.env.MODE || 'local';

const GATEWAY_LOCAL_PORT = '7201';

export const getApiPath = (
  microserviceName: string,
  // localPort: string,
  apiVersion: string = API_URL_VERSION,
) =>
  MODE === 'local'
    ? `${LOCALHOST}${GATEWAY_LOCAL_PORT}/${API}/${apiVersion}/${microserviceName}`
    : `${BASE_HOST_PROD}/${API}/${apiVersion}/${microserviceName}`;

const VACCINATION_API_NAME = 'vaccination';

export const VACCINATION_API = getApiPath(VACCINATION_API_NAME);

const KEYCLOAK_PROVIDER_API_NAME = 'keycloakProvider';
export const KEYCLOAK_PROVIDER_API = getApiPath(KEYCLOAK_PROVIDER_API_NAME);

/**
 * Параметры Keycloak задаются в env/.env.{local,dev,prod} (попадают в __ENV__ через DefinePlugin).
 * Пустое значение или отсутствие ключа — значение по умолчанию.
 */
const KEYCLOAK_URL = __ENV__.KEYCLOAK_URL || BASE_HOST_PROD;
const KEYCLOAK_REALM = __ENV__.KEYCLOAK_REALM || 'Calves';
const KEYCLOAK_CLIENT_ID = __ENV__.KEYCLOAK_CLIENT_ID || 'keycloak-provider-ms';
const KEYCLOAK_SCOPE = 'openid';
const KEYCLOAK_REDIRECT_URI =
  __ENV__.KEYCLOAK_REDIRECT_URI || `${KEYCLOAK_PROVIDER_API}/auth/oauth`;
const CALLER = __ENV__.CALLER_PROD || BASE_HOST_PROD;

/**
 * redirect_uri с параметром caller.
 *
 * caller намеренно не кодируется: keycloak-provider при обмене кода на токен
 * собирает redirect_uri как `<path>?caller=<caller>` из уже декодированного значения,
 * а Keycloak сравнивает redirect_uri посимвольно. С URLSearchParams caller стал бы
 * `http%3A%2F%2F...`, redirect_uri не совпал бы и вход перестал бы работать.
 */
const getRedirectUri = (redirectUri: string, caller: string) => {
  const url = new URL(redirectUri);
  url.search = `caller=${caller}`;
  return url.toString();
};

const getLoginUrl = () => {
  const url = new URL(
    `${KEYCLOAK_URL}/auth/realms/${encodeURIComponent(KEYCLOAK_REALM)}/protocol/openid-connect/auth`,
  );
  url.search = new URLSearchParams({
    response_type: 'code',
    client_id: KEYCLOAK_CLIENT_ID,
    scope: KEYCLOAK_SCOPE,
    redirect_uri: getRedirectUri(KEYCLOAK_REDIRECT_URI, CALLER),
  }).toString();
  return url.toString();
};

export const LOGIN_URL = getLoginUrl();

export const REFRESH_URL = `${KEYCLOAK_PROVIDER_API}/auth/token/refresh`;

const USERS_API_NAME = 'user';

export const USERS_API = getApiPath(USERS_API_NAME);

const PHARMACY_API_NAME = 'pharmacy';

export const PHARMACY_API = getApiPath(PHARMACY_API_NAME);

export const ROLES_API = `${KEYCLOAK_PROVIDER_API}/role`;
export const ROLES_WITH_PERMISSIONS_API = `${ROLES_API}/withPermissions`;
export const PERMISSIONS_API = `${KEYCLOAK_PROVIDER_API}/permission`;
